var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AlertsSummaryChart from '@web/components/DocAlerts/DocAlertsTab/AlertsSummaryChart';
import DocAlertsFilters from '@web/components/DocAlerts/DocAlertsTab/DocAlertsFilters';
import { DocAlertsTable } from '@web/components/DocAlerts/DocAlertsTab/DocAlertsTable';
import { useFilters } from '@web/utility/hooks/useFilters';
var DocAlertsTab = function () {
    var docSearch = useFilters().docSearch;
    return (_jsxs(_Fragment, { children: [_jsx(DocAlertsFilters, {}), _jsxs("div", __assign({ className: "space-y-20 mt-10" }, { children: [_jsx(DocAlertsTable, { docSearchQuery: docSearch || '' }), _jsx(AlertsSummaryChart, {})] }))] }));
};
export default DocAlertsTab;
